export class Inventario {

public CODIGOARTICULO: string;
public DISPONIBLE: number;
public APTO: number;
public NO_APTO: number;
public RESERVADO: number;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/inventario.ts